import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import Layout from '../components/feature/Layout';

const LoginPage = lazy(() => import('../pages/Login'));
const HomePage = lazy(() => import('../pages/home/page'));
const UsersPage = lazy(() => import('../pages/users/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const AuditPage = lazy(() => import('../pages/audit/page'));
const ReportsPage = lazy(() => import('../pages/reports/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const SettingsPage = lazy(() => import('../pages/settings/page'));
const TenantsPage = lazy(() => import('../pages/tenants/page'));
const PlansPage = lazy(() => import('../pages/plans/page'));
const WaitlistPage = lazy(() => import('../pages/waitlist/page'));

const routes: RouteObject[] = [
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    element: <Layout />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/users', element: <UsersPage /> },
      { path: '/resources', element: <ResourcesPage /> },
      { path: '/audit', element: <AuditPage /> },
      { path: '/reports', element: <ReportsPage /> },
      { path: '/settings', element: <SettingsPage /> },
      { path: '/tenants', element: <TenantsPage /> },
      { path: '/plans', element: <PlansPage /> },
      { path: '/waitlist', element: <WaitlistPage /> },
      { path: '*', element: <NotFound /> },
    ]
  }
];

export default routes;
